
































































































































































































































import BaseComponent from '@/core/base.component';
import { ProformaCalculatorDto } from '@/dto';
import { Component, Prop, Watch } from 'vue-property-decorator';

enum DISCOUNT_TYPE {
  WON = '￦',
  PERCENT = '%',
}
const CONST_DISCOUNT_TYPE = Object.values(DISCOUNT_TYPE);

@Component({
  name: 'ProformaCalculator',
})
export default class ProformaCalculator extends BaseComponent {
  @Prop() categoryType: string;
  @Prop() serviceCategories;

  private isToggleSticky = false;

  private discountValue = 0;
  private calculateDiscountValue = 0;
  private discountType = DISCOUNT_TYPE.WON;
  private discountTypes: DISCOUNT_TYPE[] = [...CONST_DISCOUNT_TYPE];

  private checkboxValues = [];
  get checkboxPriceValues() {
    return this.checkboxValues.map(e => e.price);
  }

  private radioValues = new ProformaCalculatorDto();
  get radioPriceValues() {
    return this.radioValues.price;
  }

  private extraServicePriceValues = [];
  private extraService = {
    title: '부가서비스',
    name: 'extra',
    items: [
      {
        id: 'extraService01',
        name: '포스피드',
        unit: '개월',
        price: 20000,
        qty: 0,
        totalPrice: 0,
      },
      {
        id: 'extraService02',
        name: '상권분석',
        unit: '개월',
        price: 100000,
        qty: 0,
        totalPrice: 0,
      },
      {
        id: 'extraService03',
        name: '매장 관리 서비스',
        unit: '개월',
        price: 200000,
        qty: 0,
        totalPrice: 0,
      },
      {
        id: 'extraService04',
        name: '사후교육',
        unit: '회',
        price: 300000,
        qty: 0,
        totalPrice: 0,
      },
    ],
  };

  get sumPrice() {
    return [
      ...this.checkboxPriceValues,
      ...this.extraServicePriceValues,
      this.radioPriceValues ? this.radioValues.price : null,
    ];
  }

  get discountPrice() {
    return this.finalTotalValue - this.totalPrice;
  }

  get totalPrice(): any {
    return this.sumPrice.reduce((a: number, b: number) => a + b, 0);
  }

  // 가격 변동
  changePrice(index) {
    const changePrice =
      this.extraService.items[index].qty * this.extraService.items[index].price;
    this.extraService.items[index].totalPrice = changePrice;
    this.extraServicePriceValues = this.extraService.items.map(
      e => e.totalPrice,
    );
  }

  // 수량 증가
  increase(index) {
    +this.extraService.items[index].qty++;
    this.changePrice(index);
  }

  // 수량 감소
  decrease(index) {
    if (this.extraService.items[index].qty < 1) return;
    +this.extraService.items[index].qty--;
    this.changePrice(index);
  }

  // 할인 가격 적용
  calculateDiscount() {
    this.calculateDiscountValue = this.discountValue;
    this.$bvModal.hide(`${this.categoryType}_discount_modal`);
  }

  // 할인 방법 선택
  selectDiscountType(type) {
    this.discountValue = 0;
    this.calculateDiscountValue = 0;
    this.discountType = type;
    this.$bvModal.show(`${this.categoryType}_discount_modal`);
  }

  // 할인 가격 취소
  cancelDiscount() {
    this.discountValue = 0;
    this.calculateDiscountValue = 0;
    this.$bvModal.hide(`${this.categoryType}_discount_modal`);
  }

  // 할인 가격 초기화
  resetDiscount() {
    this.calculateDiscountValue = 0;
  }

  // 견적 초기화
  resetProforma() {
    this.radioValues = new ProformaCalculatorDto();
    this.calculateDiscountValue = 0;
    this.checkboxValues = [];
    this.extraService.items.forEach((e, i) => {
      e.qty = 0;
      this.changePrice(i);
    });
  }

  onToggleSticky() {
    this.isToggleSticky = !this.isToggleSticky;
  }
  get stickyHeight() {
    const stickyHeight = this.$refs.proformaSticky.getBoundingClientRect()
      .height;
    return (this.$refs.proforma.style.paddingBottom = stickyHeight + 'px');
  }

  // 최종 합계
  get finalTotalValue(): any {
    if (this.discountType === DISCOUNT_TYPE.WON) {
      return this.totalPrice - this.calculateDiscountValue;
    } else if (this.discountType === DISCOUNT_TYPE.PERCENT) {
      return this.totalPrice * (1 - this.calculateDiscountValue / 100);
    } else {
      return this.totalPrice;
    }
  }

  // 매월 요금
  get monthlyFee() {
    return Math.floor(this.finalTotalValue / 12);
  }

  @Watch('finalTotalValue')
  setItem() {
    sessionStorage.setItem(
      `${this.categoryType}_checkboxValues`,
      JSON.stringify(this.checkboxValues),
    );
    sessionStorage.setItem(
      `${this.categoryType}_radioValues`,
      JSON.stringify(this.radioValues),
    );
    sessionStorage.setItem(
      `${this.categoryType}_extraServiceValues`,
      JSON.stringify(this.extraService),
    );
    sessionStorage.setItem(
      `${this.categoryType}_discountType`,
      JSON.stringify(this.discountType),
    );
    sessionStorage.setItem(
      `${this.categoryType}_discountValue`,
      JSON.stringify(this.calculateDiscountValue),
    );
  }

  getItem() {
    const getValueChecked = sessionStorage.getItem(
      `${this.categoryType}_checkboxValues`,
    );

    const getRadioValueChecked = sessionStorage.getItem(
      `${this.categoryType}_radioValues`,
    );

    const extraServiceValues = sessionStorage.getItem(
      `${this.categoryType}_extraServiceValues`,
    );

    const discountType = sessionStorage.getItem(
      `${this.categoryType}_discountType`,
    );

    const discountValue = sessionStorage.getItem(
      `${this.categoryType}_discountValue`,
    );

    if (getValueChecked) {
      this.checkboxValues = [...JSON.parse(getValueChecked)];
    }

    if (getRadioValueChecked) {
      this.radioValues = JSON.parse(getRadioValueChecked);
    }

    if (extraServiceValues) {
      this.extraService = JSON.parse(extraServiceValues);
      this.extraService.items.forEach((e, i) => {
        this.changePrice(i);
      });
    }

    if (discountType && discountValue) {
      this.discountType = JSON.parse(discountType);
      this.calculateDiscountValue = JSON.parse(discountValue);
    }
  }

  created() {
    this.getItem();
  }
}
